import { EntityTagType } from '@/types/schema';

export const mergeProviderTagsWithTags = (
  tags?: EntityTagType[] | null,
  tagsToMerge?: EntityTagType[] | null,
) => {
  const uniqueTags: Record<string, EntityTagType> = {};
  tags?.forEach((tag) => {
    uniqueTags[tag.tagId] = tag as EntityTagType;
  });
  tagsToMerge?.forEach((tag) => {
    uniqueTags[tag.tagId] = tag as EntityTagType;
  });
  return Object.values(uniqueTags);
};
